import(/* webpackMode: "eager" */ "/codebuild/output/src339562424/src/prism-app/prismx-landing/node_modules/next/dist/client/link.js");
